import { connect } from 'react-redux'
import { Component } from 'macguffin/components'
import { setSavedSettings } from 'macguffin/redux/actions'

@connect(state => ({ session: state.session }), { setSavedSettings })
export default class Settings extends Component {

  render() {
    return (
      <div className="game-settings">
      </div>
    )
  }
}
